import React, { useState, useEffect } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import Copyrights from '../Copyrights';
import Footer from '../Footer';
import SEO from '../SEO';
import '../styles/pages.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function Currency() {
  const [currencyData, setCurrencyData] = useState(null);

  useEffect(() => {
    try {
      const data = require('../../assets/data/currencies/eurofxref.json');
      setCurrencyData(data);
    } catch (error) {
      console.error('Error loading currency data:', error);
    }
  }, []);

  const options = {
    scales: {
      y: { 
        stacked: false,
        beginAtZero: true 
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#9ca3af'
        }
      },
      title: {
        display: true,
        text: 'Currency Exchange Rates',
        color: '#fff'
      },
    },
  };

  const mockChartData = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'EUR/USD',
        data: [1.05, 1.06, 1.07, 1.06, 1.05, 1.04],
        borderColor: '#06b6d4',
        backgroundColor: 'rgba(6, 182, 212, 0.1)',
        tension: 0.4,
      },
      {
        label: 'GBP/USD',
        data: [1.27, 1.28, 1.29, 1.28, 1.27, 1.26],
        borderColor: '#7c3aed',
        backgroundColor: 'rgba(124, 58, 237, 0.1)',
        tension: 0.4,
      },
    ],
  };

  return (
    <>
      <SEO
        title='Currency Exchange Rates'
        description='Real-time global currency tracking and historical exchange rate analysis for major currency pairs, powered by IURIX.'
        path='/currency'
      />
      <main className='currency'>
        <div className='section-header' style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto 3rem' }}>
          <h1>Currency Exchange Rates</h1>
          <p>Real-time global currency tracking and historical analysis</p>
        </div>

        <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '2rem', background: 'rgba(6, 182, 212, 0.05)', borderRadius: '1rem', border: '1px solid rgba(6, 182, 212, 0.1)', minHeight: '400px' }}>
          <Line data={mockChartData} options={options} />
        </div>

        {currencyData && (
          <div style={{ maxWidth: '1000px', margin: '3rem auto', padding: '2rem' }}>
            <h2 style={{ color: '#fff', marginBottom: '1.5rem' }}>Latest Rates</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '1rem' }}>
              {Object.entries(currencyData.cube).map(([currency, rate]) => (
                <div key={currency} style={{ background: 'rgba(15, 23, 42, 0.6)', padding: '1rem', borderRadius: '0.75rem', border: '1px solid rgba(6, 182, 212, 0.2)' }}>
                  <div style={{ color: '#06b6d4', fontWeight: 'bold' }}>{currency}</div>
                  <div style={{ color: '#fff', fontSize: '1.25rem' }}>{rate}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>
      <Copyrights />
      <Footer />
    </>
  );
}
